import React, { useState } from "react";

const MapAeroports = ({ aeroports }) => {
  const [showLarge, setShowLarge] = useState(false);

  // Forcer aeroports à être un tableau
  const data = Array.isArray(aeroports) ? aeroports : [aeroports];

  if (!data || data.length === 0 || !data[0]) {
    return <p className="text-gray-400 text-sm">Aucun aéroport trouvé.</p>;
  }

  const aeroport = data[0];
  const lat = aeroport.latitude;
  const lng = aeroport.longitude;

  // URL de la carte statique OpenStreetMap (via un service de tuiles statiques)
  const staticMapUrl = `https://staticmap.openstreetmap.de/staticmap.php?center=${lat},${lng}&zoom=10&size=400x200&maptype=mapnik&markers=${lat},${lng},lightblue`;

  const openStreetMapLink = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}&zoom=10`;

  return (
    <>
      {/* Carte statique cliquable */}
      <div
        className="relative cursor-pointer group rounded-xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
        onClick={() => setShowLarge(true)}
      >
        <img
          src={staticMapUrl}
          alt={`Carte de ${aeroport.name}`}
          className="w-full h-40 object-cover"
          onError={(e) => {
            e.target.onerror = null;
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
        <div className="hidden absolute inset-0 bg-gray-100 flex items-center justify-center text-gray-500 text-sm">
          Carte non disponible
        </div>
        {/* Overlay au survol */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
          <span className="text-white opacity-0 group-hover:opacity-100 transition-opacity bg-black/50 px-3 py-1.5 rounded-lg text-sm font-medium">
            Agrandir la carte ↗
          </span>
        </div>
        {/* Badge avec nom de l'aéroport */}
        <div className="absolute bottom-2 left-2 bg-white/90 backdrop-blur-sm px-2.5 py-1 rounded-lg text-xs font-medium text-gray-700 shadow">
          {aeroport.iata_code} — {aeroport.city}
        </div>
        {/* Coordonnées en petit */}
        <div className="absolute top-2 right-2 bg-black/50 backdrop-blur-sm px-2 py-0.5 rounded text-[10px] text-white/80 font-mono">
          {parseFloat(lat).toFixed(2)}, {parseFloat(lng).toFixed(2)}
        </div>
      </div>

      {/* Lien direct OpenStreetMap */}
      <a
        href={openStreetMapLink}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block mt-1 text-xs text-blue-600 hover:text-blue-800 hover:underline"
      >
        Voir sur OpenStreetMap ↗
      </a>

      {/* Modal agrandi au clic */}
      {showLarge && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
          onClick={() => setShowLarge(false)}
        >
          <div
            className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-3 border-b bg-gradient-to-r from-blue-50 to-white">
              <div>
                <h3 className="font-bold text-gray-800">{aeroport.name}</h3>
                <p className="text-sm text-gray-500">{aeroport.city}, {aeroport.country}</p>
              </div>
              <button
                onClick={() => setShowLarge(false)}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-200 hover:bg-red-500 hover:text-white transition text-gray-600"
              >
                ✕
              </button>
            </div>

            {/* Grande carte statique */}
            <div className="p-4 bg-gray-50">
              <img
                src={`https://staticmap.openstreetmap.de/staticmap.php?center=${lat},${lng}&zoom=11&size=600x400&maptype=mapnik&markers=${lat},${lng},lightblue`}
                alt={`Carte de ${aeroport.name}`}
                className="w-full h-auto rounded-xl shadow-inner border"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="hidden w-full h-64 bg-gray-200 rounded-xl items-center justify-center text-gray-500">
                Carte non disponible
              </div>
            </div>

            {/* Footer */}
            <div className="px-5 py-3 border-t bg-gray-50 flex items-center justify-between text-sm">
              <span className="text-gray-500">
                📍 {parseFloat(lat).toFixed(4)}, {parseFloat(lng).toFixed(4)}
              </span>
              <a
                href={openStreetMapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded-lg text-sm font-medium transition"
              >
                Ouvrir dans OpenStreetMap ↗
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MapAeroports;